import React, { useEffect, useMemo, useState } from 'react';

import './_dropdown.container.scss'
import './_dropdown.container.dark-mode.scss'

import classNames from 'classnames';
import PropTypes from 'prop-types';
import { useDropdown } from '../useDropdown';
import { getPositionStyles } from '../helpers';
import { UI_NAME } from '../../../../utils/config';
import { marginClasses, paddingClasses } from '../../../../utils/styles';

const DropdownContainer = ({ position, offset, width, children, className, ...props }) => {
  const { isOpen, containerRef } = useDropdown();
  const [isRendered, setIsRendered] = useState(false);
  const [isAnimating, setIsAnimating] = useState(false);

  useEffect(() => {
    if (isOpen) {
      setIsRendered(true);
    } else {
      // Запускаем анимацию закрытия
      setIsAnimating(false);
      const timer = setTimeout(() => setIsRendered(false), 250);
      return () => clearTimeout(timer);
    }
  }, [isOpen]);

  useEffect(() => {
    if (isRendered && isOpen) {
      // Задержка для активации анимации открытия
      requestAnimationFrame(() => {
        setIsAnimating(true);
      });
    }
  }, [isRendered, isOpen]);

  // eslint-disable-next-line react-hooks/exhaustive-deps
  const getInitialTransform = () => {
    switch (position) {
    case 'top': return 'translateY(10px)';
    case 'bottom': return 'translateY(-10px)';
    case 'left': return 'translateX(10px)';
    case 'right': return 'translateX(-10px)';
    default: return 'none';
    }
  };

  // eslint-disable-next-line react-hooks/exhaustive-deps
  const getFinalTransform = () => {
    switch (position) {
    case 'top':
    case 'bottom': return 'translateY(0)';
    case 'left':
    case 'right': return 'translateX(0)';
    default: return 'none';
    }
  };

  const style = useMemo(() => ({
    width,
    zIndex: 10,
    position: 'absolute',
    opacity: isAnimating ? 1 : 0,
    transform: isAnimating ? getFinalTransform() : getInitialTransform(),
    transition: 'all 0.25s ease', // Переход всегда активен
    pointerEvents: isOpen ? 'auto' : 'none',
    ...getPositionStyles(position, offset),
  }), [width, isAnimating, getFinalTransform, getInitialTransform, isOpen, position, offset]);

  const classes = classNames(`${UI_NAME}-dropdown__container`,
    ...marginClasses(props),
    ...paddingClasses(props),
    className);

  if (!isRendered) return null;

  return (
    <div ref={containerRef} style={style} className={classes}>
      {children}
    </div>
  );
};

DropdownContainer.defaultProps = {
  position: 'bottom',
  offset: 8,
}

DropdownContainer.propTypes = {
  position: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  offset: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  width: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  children: PropTypes.node,
  className: PropTypes.string,
}

export default DropdownContainer;
